import { Box, Button, Icon } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import DurationInput from 'modules/core/components/DurationInput'
import i18n from 'modules/core/lib/i18n'

import type RuleForm from '../form'
import type DurationRuleForm from '../form'

interface Props {
  form: RuleForm
  onAdd: () => void
  onDelete: (form: DurationRuleForm) => void
  canAdd: boolean
  rulesSize: number
}

const RuleItem = ({ form, onAdd, onDelete, canAdd, rulesSize }: Props) => {
  const periodLengthInMinutes = form.get('periodLength').value
    ? Math.round(form.get('periodLength').value * 60)
    : 0
  const minimalDurationInMinutes = form.get('minimalDuration').value || 0

  const handlePeriodLengthChange = (minutes: number) => {
    form.get('periodLength').set(minutes / 60)
  }

  const handleMinimalDurationChange = (minutes: number) => {
    form.get('minimalDuration').set(minutes)
  }

  return (
    <Box flexDirection="row" gap="s8" alignItems="center">
      <Box minWidth="s140">
        <DurationInput
          label={i18n.t('time_tracking.settings.breaks.instance.duration_rules.worked_hours')}
          minutes={periodLengthInMinutes}
          onChange={handlePeriodLengthChange}
        />
      </Box>
      <Box paddingTop="s24">
        <Icon.Medium icon="arrow-right" />
      </Box>
      <Box minWidth="s140">
        <DurationInput
          label={i18n.t('time_tracking.settings.breaks.instance.duration_rules.break_time')}
          minutes={minimalDurationInMinutes}
          onChange={handleMinimalDurationChange}
        />
      </Box>
      <Box paddingTop="s24" flexDirection="row" gap="s4">
        <Button
          type="secondary"
          disabled={rulesSize === 1}
          onClick={() => onDelete(form)}
          iconName="delete"
        />
        {canAdd && (
          <Button
            type="secondary"
            onClick={onAdd}
            disabled={!(form.get('periodLength').value && form.get('minimalDuration').value)}
            iconName="add"
          />
        )}
      </Box>
    </Box>
  )
}

export default observer(RuleItem)
